<!-- 我的考场 -->
<template>
  <div class="exam">
    <div class="wrap">
      <div class="list">
        <div
          class="item"
          v-for="item in list"
          :key="item.id"
          @click="getTestDetail(item)"
        >
          <div class="top">
            <div class="title">{{ item.paperTitle }}</div>
            <div class="desc">{{ item.subjectName }}</div>
            <div class="status">
              <el-tag type="success" v-if="item.examinationStatus == 1"
                >通过</el-tag
              >
              <el-tag type="danger" v-if="item.examinationStatus == 0"
                >未通过</el-tag
              >
            </div>
          </div>
          <div class="middle">
            <div class="info">
              <div class="info-item">
                <div class="label">身份证：</div>
                <div class="value">{{ item.applyIdNo }}</div>
              </div>
              <div class="info-item">
                <div class="label">姓名：</div>
                <div class="value">{{ item.applyUserName }}</div>
              </div>
              <div class="info-item">
                <div class="label">手机号：</div>
                <div class="value">{{ item.applyPhoneNo }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="empty" v-show="list.length == 0">
        <el-empty description="暂无考试"></el-empty>
      </div>
      <el-pagination
        class="pagination"
        background
        :hide-on-single-page="total < 11"
        @current-change="currentChange"
        :current-page.sync="queryParams.pageIndex"
        :page-size="queryParams.pageSize"
        layout="prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryParams: {
        pageIndex: 1,
        pageSize: 50,
      },
      list: [],
      total: 0,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    currentChange(val) {
      this.queryParams.pageIndex = val;
      this.getList();
    },
    async getList() {
      let res = await this.$api.getTestRecord(this.queryParams);
      this.list = res.data.list;
      this.total = res.data.total;
    },
    // 前往查看考试结果详情
    getTestDetail(item) {
      this.$router.push("/testResult/" + item.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  width: 100%;

  .list {
    display: flex;
    flex-wrap: wrap;

    .item {
      width: 49%;
      padding: 20px;
      box-sizing: border-box;
      box-shadow: 0 0 5px #ccc;
      transition: 0.5s;
      border-radius: 5px;
      margin-bottom: 10px;

      &:hover {
        transform: translateY(-10px);
        cursor: pointer;
      }
      &:nth-child(2n) {
        margin-left: 10px;
      }

      .top {
        position: relative;

        .title {
          font-size: 20px;
        }
        .desc {
          color: #999;
          font-size: 14px;
        }
      }
      .title {
        font-weight: bold;
        padding-left: 10px;
        position: relative;

        &::before {
          content: "";
          width: 4px;
          height: 60%;
          border-radius: 5px;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          background-color: $theme;
        }
      }
      .desc {
        font-size: 14px;
        color: #999;
      }
      .status {
        position: absolute;
        right: 0;
        top: 0;
      }
      // .part {
      //   padding-left: 10px;
      // }
      .info {
        margin-top: 10px;
        font-size: 14px;
        color: #999;

        .info-item {
          display: flex;
          line-height: 22px;

          .value {
            color: #666;
          }
        }
      }
    }
  }
}
</style>
